<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <!-- 左侧菜单 -->
      <navMenu :active="active"></navMenu>
      <!-- 右侧内容区域 -->
      <div class="content" v-loading.lock="loading">
        <div class="main-title">
          {{ language === "cn" ? "展商认证" : "Exhibitor Certification" }}
        </div>
        <div class="template-main content_box">
          <div class="content_html" v-html="content"></div>
        </div>
        <div class="conf-btn flex">
          <!-- 可跳过需要验证 -->
          <template v-if="detail.is_skip == 1 && detail.is_verify == 1">
            <div class="btn" @click="next('skip')">
              {{ language === "cn" ? "跳过" : "Skip" }}
            </div>
            <div class="btn next-btn" @click="next('next')">
              {{ language === "cn" ? "下一步" : "Next Step" }}
            </div>
          </template>
          <!-- 可跳过无需验证 -->
          <template v-if="detail.is_skip == 1 && detail.is_verify == 0">
            <!-- 24.9.1 已知悉改成下一步 dxm-->
            <!-- 24.10.15 zhang  不可配置 ljj 展商认证添加跳过按钮 -->
            <div class="btn" @click="next('skip')">
              {{ language === "cn" ? "跳过" : "Skip" }}
            </div>
            <div class="btn next-btn" @click="next('known')">
              {{ language === "cn" ? "下一步" : "Next Step" }}
            </div>
          </template>
          <!-- 不可跳过需要验证 -->
          <template v-if="detail.is_skip == 0 && detail.is_verify == 1">
            <div class="btn next-btn" @click="next('next')">
              {{ language === "cn" ? "下一步" : "Next Step" }}
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { skipOrNextStep, companyMenuDetail } from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
export default {
  components: { top, navMenu },
  name: "exhibitor",
  data() {
    return {
      id: "",
      loading: false,
      active: 0,
      content: "",
      detail: {},
      language: "",
    };
  },
  mounted() {
    this.getData();
  },
  created() {
    this.language = localStorage.getItem("language");
  },
  methods: {
    // 初始化数据
    getData() {
      let stepMenuList = JSON.parse(localStorage.getItem("menu"));
      console.log(stepMenuList);
      this.stepMenuList = stepMenuList;
      var index = stepMenuList.findIndex(function (item) {
        return item.link_url == "/exhibitor";
      });
      this.detail = stepMenuList[index];
      this.active = index;
      this.id = stepMenuList[index].id;
      // 获取页面标题 副标题 富文本
      this.getContent(this.id);
    },
    //  获取内容
    getContent(id) {
      this.loading = true;
      companyMenuDetail({ id })
        .then((res) => {
          //console.log(res, "<======res");
          this.loading = false;
          if (res.data.code == 1) {
            let { data } = res.data;
            if (this.language === "cn") {
              if (data.content) {
                data.content = data.content.replace(
                  /<img/g,
                  "<img style='max-width:100%;height:auto;'"
                );
                data.content = data.content.replace(
                  /<p/g,
                  "<p style='max-width:100%;'"
                );
              }
              this.content = data.content;
            } else if (this.language === "en") {
              if (data.content_en) {
                data.content_en = data.content_en.replace(
                  /<img/g,
                  "<img style='max-width:100%;height:auto;'"
                );
                data.content_en = data.content_en.replace(
                  /<p/g,
                  "<p style='max-width:100%;'"
                );
              }
              this.content = data.content_en;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 跳转下一步
    next(type) {
      if (type == "next") {
        //下一步
        // if (this.detail.action == 1 || this.detail.action == 4) {
        //   this.toPath();
        // } else {
        //   this.$message.warning("请完善信息!");
        // }
        if (this.detail.action >= 2) {
          this.toPath();
        } else if (this.detail.is_verify == 1) {
          this.$message.warning("请完善信息!");
        } else {
          this.toPath();
        }
      } else if (type == "skip") {
        //跳过
        this.skipOrReadStep(1);
      } else if (type == "known") {
        //已知悉
        this.skipOrReadStep(2);
      }
    },
    // 跳过或者已知悉
    skipOrReadStep(action) {
      let data = {
        action,
        mark: this.detail.mark,
      };
      skipOrNextStep(data)
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success(
              this.language === "cn" ? "操作成功" : "Operation successful"
            );
            this.toPath();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toPath() {
      this.active = this.active + 1;
      let { link_url, id } = this.stepMenuList[this.active];
      if (link_url == "conference") {
        this.$router.push({
          path: link_url,
          query: {
            id,
          },
        });
      } else {
        this.$router.push({
          path: link_url,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.template-main {
  margin-top: 30px;
}
.content_box {
  display: flex;
  justify-content: center;
  .content_html {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 10px;
    background: #fff;
    line-height: 30px;
    p > img {
      width: 100px !important;
      background-color: red !important;
    }
  }
}
.conf-btn {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  .btn {
    min-width: 148px;
    height: 40px;
    cursor: pointer;
    font-size: 19px;
    margin: 0 10px;
    font-weight: 500;
    color: #2690e6;
    line-height: 40px;
    text-align: center;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #008dff;
    &:hover {
      text-decoration: underline;
    }
  }
  .next-btn {
    color: #fff;
    background: #008dff;
  }
}
@media only screen and (max-width: 767px) {
  .template-main {
    margin-top: 10px;
  }
  .content {
    margin: 0;
    padding: 20px 20px 150px 20px;
    .content_html {
      width: 100%;
    }
  }
}
</style>